export enum LimitType {
  Max = 'Max',
  Min = 'Min',
}
